import React from 'react';
import { Link } from 'react-router-dom';
import { FaStripe, FaInstagram, FaTiktok } from 'react-icons/fa';
import { GrAmex } from 'react-icons/gr';
import { SiVisa, SiMastercard } from 'react-icons/si';

const FOOTER_SECTIONS = [
  {
    title: 'PonPon',
    links: [
      { label: 'About', to: '/about' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Tutorial', to: '/tutorial' },
    ],
  },
  {
    title: 'Learn',
    links: [
      { label: 'What Is Online Gachapon?', to: '/online-gachapon' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms', to: '/terms' },
      { label: 'Privacy', to: '/privacy' },
      { label: 'Return & Refund', to: '/return-refund' },
    ],
  },
];

const SiteFooter = () => (
  <footer className="border-t border-white/60 pb-24 pt-6 text-sm text-ponpon-navy/60">
    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
      <div className="mb-6 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="text-lg font-semibold text-ponpon-navy">FOLLOW US ON</span>
          <div className="flex items-center gap-4 text-ponpon-navy/50">
            <a
              href="https://www.instagram.com/ponpon.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition hover:text-ponpon-navy"
              aria-label="Instagram"
            >
              <FaInstagram className="h-10 w-10" />
            </a>
            <a
              href="https://www.tiktok.com/@ponpon.app"
              target="_blank"
              rel="noopener noreferrer"
              className="transition hover:text-ponpon-navy"
              aria-label="TikTok"
            >
              <FaTiktok className="h-10 w-10" />
            </a>
          </div>
        </div>
        <div className="flex flex-col gap-6 sm:flex-row sm:gap-8">
          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title} className="flex flex-col gap-2">
              <h3 className="text-sm font-semibold text-ponpon-navy">{section.title}</h3>
              <nav className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-ponpon-navy/70 transition hover:text-ponpon-navy"
                  >
                    {link.label}
        </Link>
                ))}
      </nav>
    </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-ponpon-navy/60">© {new Date().getFullYear()} PonPon!</p>
      <div className="flex items-center gap-3 text-ponpon-navy/50">
        <FaStripe className="h-6 w-auto" aria-label="Stripe" />
        <SiVisa className="h-6 w-auto" aria-label="Visa" />
        <SiMastercard className="h-6 w-auto" aria-label="Mastercard" />
        <GrAmex className="h-6 w-auto" aria-label="American Express" />
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
